import ApplicationController from "./application_controller"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
        this.form = this.element;
    }

    addRechten() {
        if (this.form.niveau.selectedIndex < 1) {
            alert('Gelieve een niveau te selecteren');
            return;
        }

        var r_item_id = this.form.niveau.options[this.form.niveau.selectedIndex].value;
        var r_item = this.form.niveau.options[this.form.niveau.selectedIndex].text;

        var r_item_instance_id = '', r_item_instance = '', r_permit_id = '', r_permit = '';

        if (r_item_id == '4') {
            if (this.form.provincie.selectedIndex < 1) {
                alert('Gelieve een provincie te selecteren');
                return;
            }
            r_item_instance_id = this.form.provincie.options[this.form.provincie.selectedIndex].value;
            r_item_instance = this.form.provincie.options[this.form.provincie.selectedIndex].text;
        } else if (r_item_id == '3') {
            if (this.form.federatie.selectedIndex < 1) {
                alert('Gelieve een federatie te selecteren');
                return;
            }
            r_item_instance_id = this.form.federatie.options[this.form.federatie.selectedIndex].value;
            r_item_instance = this.form.federatie.options[this.form.federatie.selectedIndex].text;
        } else if (r_item_id == '2') {
            if (this.form.afdeling.selectedIndex < 1) {
                alert('Gelieve een afdeling te selecteren');
                return;
            }
            r_item_instance_id = this.form.afdeling.options[this.form.afdeling.selectedIndex].value;
            r_item_instance = this.form.afdeling.options[this.form.afdeling.selectedIndex].text;
        }

        if (this.form.toelating.selectedIndex < 1) {
            alert('Gelieve een toelating te selecteren');
            return;
        }

        r_permit_id = this.form.toelating.options[this.form.toelating.selectedIndex].value;
        r_permit = this.form.toelating.options[this.form.toelating.selectedIndex].text;

        let dt = this.form.querySelector("#dynatable_rechten");
        dt.dynatable.addItem({
            r_item_id: r_item_id,
            r_item: r_item,
            r_item_instance_id: r_item_instance_id,
            r_item_instance: r_item_instance,
            r_permit_id: r_permit_id,
            r_permit: r_permit
        });

    }

    getRandomNum() {
        // between 0 - 1
        var rndNum = Math.random()
        // rndNum from 0 - 1000
        rndNum = parseInt(rndNum * 1000);
        // rndNum from 33 - 127
        rndNum = (rndNum % 94) + 33;
        return rndNum;
    }

    checkPunc(num) {
        if ((num >= 33) && (num <= 47)) {
            return true;
        }
        if ((num >= 58) && (num <= 64)) {
            return true;
        }
        if ((num >= 91) && (num <= 96)) {
            return true;
        }
        if ((num >= 123) && (num <= 126)) {
            return true;
        }
        return false;
    }

    generatePassword() {
        var length = 8;
        var sPassword = "";

        for (let i = 0; i < length; i++) {

            let numI = this.getRandomNum();
            while (this.checkPunc(numI)) {
                numI = this.getRandomNum();
            }
            sPassword = sPassword + String.fromCharCode(numI);
        }

        this.form.paswoord.value = sPassword;
        this.form.paswoord_verify.value = sPassword;

        alert("Noteer het paswoord het is " + sPassword);
    }

    disconnect() {
        super.disconnect();
    }
}
